import React, { useState } from 'react';
import axios from 'axios';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import API_BASE_URL from '../apiConfig'; // <--- NEW IMPORT
import '../App.css'; 

// --- CHANGED URL HERE ---
const CONTACT_API_URL = `${API_BASE_URL}/contact`;
// -----------------------

function ContactPage() {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const [status, setStatus] = useState(''); 

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setStatus('');
        
        try {
            await axios.post(CONTACT_API_URL, {
                name: name,
                email: email,
                message: message
            });
            
            setStatus('success');
            setName(''); setEmail(''); setMessage(''); 
            
        } catch (error) {
            console.error("Contact form error:", error);
            setStatus('error');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="App">
            <Navbar />
            <header className="App-header" style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                <div className="form-container" style={{maxWidth: '550px', width: '100%'}}>
                    <h2 style={{textAlign: 'center', marginBottom: '30px'}}>Contact Support</h2>
                    
                    {status === 'success' && (
                        <p style={{color: 'green', fontWeight: 'bold', textAlign: 'center', marginBottom: '20px'}}>
                            ✅ Message Sent! We've received your inquiry and will respond within 24–48 hours.
                        </p>
                    )}
                    
                    {status === 'error' && <p className="error-message">❌ Failed to send message. Please try again or email support@luxerassess.com directly.</p>}

                    <form onSubmit={handleSubmit}>
                        <div className="input-row" style={{gap: '20px'}}>
                            <div className="form-group" style={{flex: 1}}>
                                <label>Your Name</label>
                                <input type="text" value={name} onChange={(e) => setName(e.target.value)} required disabled={loading} />
                            </div>
                            <div className="form-group" style={{flex: 1}}>
                                <label>Your Email</label>
                                <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required disabled={loading} />
                            </div>
                        </div>

                        <div className="form-group">
                            <label>How can we help?</label>
                            <textarea rows="5" value={message} onChange={(e) => setMessage(e.target.value)} required disabled={loading} />
                        </div>

                        <button className="generate-button" type="submit" disabled={loading} style={{width: '100%', marginTop: '20px'}}>
                            {loading ? 'Sending...' : 'Send Message'}
                        </button>
                    </form>
                </div>
            </header>
            <Footer />
        </div>
    );
}

export default ContactPage;